
import { UserRolePermissionViewModel } from "../view-models/user-role-permission.view-model"
import { Permission } from "./enums"

export const PERMISSION_STRUCTURE: Array<UserRolePermissionViewModel> = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true),
    new UserRolePermissionViewModel(Permission.MEASURE,true,true,true,false,
    [
        new UserRolePermissionViewModel(Permission.INFOS, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, true),
        new UserRolePermissionViewModel(Permission.MILESTONES, true),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, true),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, true),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, true),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, true),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true),
        new UserRolePermissionViewModel(Permission.TASKS, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true),
    ]),
    new UserRolePermissionViewModel(Permission.MILESTONES, true),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.PROJECT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.ROLES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, true, true, true, true),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, true, true, true, true),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true),
    new UserRolePermissionViewModel(Permission.GANTT, true),
    new UserRolePermissionViewModel(Permission.REPORT, true),
    new UserRolePermissionViewModel(Permission.ROLE_RIGHTS, true)
].sort((a, b) => a.Context.localeCompare(b.Context))